export default [
    "14DAH",
    "1ADAI",
    "1ADOA",
    "1AIO",
    "1AIOA",
    "1CGO",
    "1CGOA",
    "1MCAAB",
    "3DAAJ",
    "3DAO",
    "3MFO",
    "4DXO",
    "88EOA",
    "8COAI",
    "AAJO",
    "AAPAI",
    "AARO",
    "AAUAN",
    "AAUO",
    "AAUOB",
    "AAUOC",
    "ABXO",
    "ACBO",
    "ACEAS",
    "ACMO",
    "ACMOA",
    "ACQAI",
    "ACQAK",
    "ACWAO",
    "ACWAQ",
    "ACWOC",
    "ACWOD",
    "ADCO",
    "ADDAAD",
    "ADDAU",
    "ADDOA",
    "ADDOC",
    "ADGO",
    "ADGOA",
    "ADNOC",
    "ADOO",
    "ADOOA",
    "ADRAR",
    "ADSAH",
    "ADSAK",
    "ADXO",
    "AEEAI",
    "AEEAW",
    "AEEO",
    "AEEOC",
    "AEVAY",
    "AEVO",
    "AGDAI",
    "AGEAK",
    "AGEOC",
    "AGRO",
    "AGSAO",
    "AHFAK",
    "AHGOB",
    "AHKAI",
    "AHNO",
    "AHQAAB",
    "AI1O",
    "AIVO",
    "AIWAI",
    "AIWAM",
    "AIYAK",
    "AJQOA",
    "AKDO",
    "AKNAQ",
    "AKNO",
    "AKOO",
    "AL8AS",
    "ALBO",
    "ALROB",
    "ALTAI",
    "ALTAU",
    "ALTAW",
    "ALTOB",
    "ALYAP",
    "AMEAI",
    "AMLAS",
    "AMSO",
    "AN1OA",
    "ANLOA",
    "ANPAF",
    "ANPAH",
    "ANRAT",
    "ANWAI",
    "ANXAQ",
    "ANXO",
    "AOPAK",
    "AOUAT",
    "APCAG",
    "APCO",
    "APKO",
    "APUO",
    "AQDAM",
    "AQLAM",
    "AQXAX",
    "AQXO",
    "AQXOA",
    "AQXOB",
    "AQXOC",
    "AR9O",
    "ARDO",
    "ARDOC",
    "ARHAE",
    "ARLAI",
    "ARNO",
    "AROAI",
    "AROAQ",
    "ARUO",
    "ARUOA",
    "ARVAI",
    "ARVOC",
    "ARWAK",
    "AS2O",
    "AS2OA",
    "ASEO",
    "ASMO",
    "ASNAT",
    "ASNOC",
    "ASNOD",
    "ASRAS",
    "ASRO",
    "ASROB",
    "ATCOC",
    "ATHO",
    "ATIAM",
    "ATNAI",
    "ATPAI",
    "ATUAI",
    "ATVO",
    "ATXAI",
    "ATXO",
    "ATXOA",
    "AUEO",
    "AUHO",
    "AUKO",
    "AUKOA",
    "AUNO",
    "AUNOB",
    "AUNOC",
    "AUQO",
    "AURO",
    "AUZAL",
    "AUZO",
    "AUZOA",
    "AUZOB",
    "AVEO",
    "AVEOA",
    "AVMO",
    "AVWOA",
    "AW1AH",
    "AW1O",
    "AWJO",
    "AWJOA",
    "AXIAY",
    "AXIO",
    "AXLDB",
    "AXLO",
    "AYRAO",
    "AZ9O",
    "AZLO",
    "AZLOA",
    "AZYAAE",
    "BARAO",
    "BASO",
    "BATO",
    "BBRAW",
    "BC8O",
    "BCBAR",
    "BCMO",
    "BCMOA",
    "BCNOD",
    "BIGO",
    "BIRAC",
    "BITOC",
    "BIVAI",
    "BKTAU",
    "BLGO",
    "BLTAD",
    "BLYO",
    "BLZAI",
    "BLZO",
    "BLZOB",
    "BM8AL",
    "BMGAM",
    "BMNAB",
    "BMOAU",
    "BMOOA",
    "BNRO",
    "BNROA",
    "BOAO",
    "BOAOA",
    "BOSDC",
    "BP8O",
    "BPHO",
    "BPHOB",
    "BPHOE",
    "BPMO",
    "BPMOA",
    "BPMOB",
    "BPOAU",
    "BRDAI",
    "BRXO",
    "BRXOA",
    "BSAO",
    "BTDOA",
    "BUCO",
    "BUDOA",
    "BUXO",
    "BUYO",
    "BXNAI",
    "BYHO",
    "CAIO",
    "CAIOA",
    "CANAK",
    "CANAN",
    "CAOXE",
    "CAVAI",
    "CAZAF",
    "CBDOC",
    "CBHO",
    "CBHOA",
    "CBLAU",
    "CC5OA",
    "CCOO",
    "CCOOA",
    "CCZO",
    "CCZOA",
    "CCZOB",
    "CDEO",
    "CDRO",
    "CDTO",
    "CDTOA",
    "CDTOB",
    "CDXOA",
    "CG1O",
    "CGBAO",
    "CGMAM",
    "CHKAI",
    "CHKAK",
    "CHMO",
    "CIRXE",
    "CKGOA",
    "CL8AQ",
    "CL8AV",
    "CL8O",
    "CL8OB",
    "CLAO",
    "CLBDB",
    "CLBO",
    "CLZAO",
    "CLZAV",
    "CLZOA",
    "CM8AI",
    "CMCAI",
    "CMLAD",
    "CMOAI",
    "CMOO",
    "CMWAK",
    "CMXO",
    "CNDOA",
    "CNJAK",
    "CNJO",
    "CNJOB",
    "CNQO",
    "CODO",
    "COMAI",
    "CPHAO",
    "CPMO",
    "CPMOA",
    "CPOO",
    "CR3OD",
    "CR9O",
    "CRBAM",
    "CRIO",
    "CSFO",
    "CT1AI",
    "CTLO",
    "CTOOA",
    "CUEOA",
    "CUFO",
    "CUSAH",
    "CVTAM",
    "CVVAQ",
    "CVVOB",
    "CXMAN",
    "CXMAT",
    "CXUAAA",
    "CXUAAE",
    "CXUO",
    "CXUOA",
    "CYLAI",
    "CYMAAC",
    "CYMAAG",
    "CYPOA",
    "CYQOA",
    "CYTAI",
    "CZNAU",
    "CZNOA",
    "D2OO",
    "D2OOA",
    "DESO",
    "DGOAI",
    "DGOAK",
    "DGOOA",
    "DGRAU",
    "DGRO",
    "DHRAK",
    "DHRAM",
    "DIDO",
    "DIOAZ",
    "DM1O",
    "DMMO",
    "DOUO",
    "DRXAI",
    "DTMAAA",
    "DTMAX",
    "DTRO",
    "DUNO",
    "DXBAZ",
    "DXBO",
    "DXNOD",
    "DY6AN",
    "ECEOB",
    "ECSO",
    "EDEAK",
    "EDEAM",
    "EDEO",
    "EDEOC",
    "EDEOD",
    "EDEOE",
    "EERAI",
    "EGLAK",
    "EGSAI",
    "EGSAK",
    "EGYO",
    "EHRAO",
    "EHRAQ",
    "ELSOA",
    "ELTAAB",
    "ELTAI",
    "EM2AI",
    "EM2AK",
    "EM2AV",
    "EM2AW",
    "EM2O",
    "EMCOA",
    "EMDAW",
    "EMPO",
    "EMSAH",
    "EMTO",
    "EMUAK",
    "EMUAM",
    "EN1AG",
    "ENAAQ",
    "ENTAAG",
    "ENTAI",
    "ENTAK",
    "ENTAY",
    "ENVO",
    "ENXAB",
    "EPMAT",
    "EPMOA",
    "ERLAQ",
    "ESRO",
    "ESROA",
    "ESROB",
    "ESROC",
    "ETMO",
    "ETRO",
    "EURO",
    "EUROA",
    "EUROB",
    "EVGO",
    "EVRO",
    "EVROA",
    "EWCAE",
    "EXLO",
    "EXOAI",
    "EXROB",
    "EXTOD",
    "FAUO",
    "FAUOA",
    "FFFO",
    "FFGAI",
    "FFGO",
    "FG1O",
    "FGHAAE",
    "FGLOA",
    "FGXO",
    "FL1O",
    "FL1OB",
    "FMEO",
    "FMEOA",
    "FNDOB",
    "FRSO",
    "FRSOA",
    "FRSOB",
    "FXGO",
    "G88O",
    "G88OA",
    "GASAJ",
    "GBGAB",
    "GBIAO",
    "GBZAK",
    "GBZAQ",
    "GBZOB",
    "GC1AI",
    "GDCOB",
    "GEDO",
    "GEDOB",
    "GENAQ",
    "GERAK",
    "GESAK",
    "GGEAX",
    "GGEO",
    "GGEOA",
    "GGEOB",
    "GGSO",
    "GGXAK",
    "GLHAK",
    "GLLO",
    "GLNOB",
    "GLOAK",
    "GMDAAB",
    "GMDAI",
    "GMDAU",
    "GMDAY",
    "GMLAI",
    "GMLO",
    "GMNO",
    "GMNOB",
    "GMNOC",
    "GNEO",
    "GNMOB",
    "GNMOC",
    "GO2AI",
    "GPPAI",
    "GPRAM",
    "GR8AF",
    "GRLAI",
    "GRLAN",
    "GRLO",
    "GRLOA",
    "GSCAM",
    "GSMAI",
    "GSRO",
    "GTGAAB",
    "GTNO",
    "GTRAL",
    "GTRO",
    "GTROA",
    "GTROB",
    "GTROC",
    "HARO",
    "HASO",
    "HCDAD",
    "HCDAG",
    "HCDAJ",
    "HCHAI",
    "HCOAF",
    "HIOO",
    "HIQAQ",
    "HIQO",
    "HLXO",
    "HMCO",
    "HMDO",
    "HPCAU",
    "HRZO",
    "HRZOB",
    "HTGO",
    "HTMAI",
    "HTMO",
    "HWKO",
    "HWKOA",
    "HYDOA",
    "HYDOB",
    "HYTO",
    "HYTOA",
    "HYTOB",
    "HYTOC",
    "HZRO",
    "IAMO",
    "IAMOB",
    "IBIO",
    "IBXAI",
    "IBXOA",
    "ICGO",
    "ICGOC",
    "ICGOD",
    "ICGOE",
    "ICGOF",
    "ICLO",
    "ICQAI",
    "ICRO",
    "ID8O",
    "IDTAI",
    "IFCAK",
    "IHLAL",
    "IHLAW",
    "IHLAY",
    "IHLAZ",
    "IIQO",
    "ILAO",
    "IMCAK",
    "IMIO",
    "IMUO",
    "IMUOD",
    "IMUOE",
    "INDO",
    "INFAM",
    "IPBAM",
    "IPDAC",
    "IPTO",
    "IPTOB",
    "ITCAZ",
    "IVRO",
    "IVXO",
    "IVZO",
    "IVZOA",
    "IXUAT",
    "JATO",
    "JAVO",
    "JAVOA",
    "JAVOB",
    "JLLO",
    "JLLOA",
    "JMSAN",
    "KALAF",
    "KATO",
    "KBUAQ",
    "KFMO",
    "KINAM",
    "KLIAH",
    "KNBAL",
    "KNBO",
    "KNGO",
    "KNMAV",
    "KPOAO",
    "KTLAK",
    "L1MO",
    "LAWAAC",
    "LBTAAC",
    "LBTO",
    "LCLO",
    "LCTAP",
    "LDRO",
    "LFRAM",
    "LGMO",
    "LGOAI",
    "LI3AO",
    "LIOO",
    "LIOOA",
    "LITOA",
    "LITOB",
    "LKEAK",
    "LKEAM",
    "LKOAK",
    "LKOAO",
    "LMGO",
    "LMLOA",
    "LNRO",
    "LPDO",
    "LPDOD",
    "LPDOE",
    "LPEO",
    "LRDO",
    "LRFAI",
    "LRFAK",
    "LRFAM",
    "LRTAC",
    "LRVO",
    "LSLAK",
    "LSRAO",
    "LSRAQ",
    "LU7O",
    "LU7OA",
    "LV1AK",
    "LV1OA",
    "LYKO",
    "LYKOA",
    "M2MO",
    "M2RO",
    "M2ROA",
    "M4MOB",
    "MATAS",
    "MATO",
    "MAYAI",
    "MBKAQ",
    "MBKAS",
    "MBKO",
    "MCROA",
    "MCTAI",
    "MCTOA",
    "MDIAU",
    "MDIAW",
    "MDIAX",
    "ME1O",
    "ME1OD",
    "ME1OE",
    "MEIO",
    "MELAB",
    "MELAE",
    "MELOB",
    "MEMAS",
    "MFGO",
    "MG1O",
    "MGAO",
    "MGFO",
    "MGTO",
    "MGTOA",
    "MGTOE",
    "MGUO",
    "MHCO",
    "MIOO",
    "MKBAK",
    "MKBAM",
    "MKGAJ",
    "MLMAK",
    "MLMOB",
    "MLSOC",
    "MLSOD",
    "MMRAO",
    "MMRO",
    "MMZAM",
    "MNBOA",
    "MNBOB",
    "MNCAK",
    "MODAY",
    "MOHO",
    "MOHOA",
    "MOHOB",
    "MOOAI",
    "MPKO",
    "MPRO",
    "MPXAG",
    "MRDAN",
    "MRIAX",
    "MRQO",
    "MRQOC",
    "MRRAM",
    "MRRO",
    "MSCAK",
    "MTBO",
    "MTHO",
    "MTLOA",
    "MTMO",
    "MTMOB",
    "MTNAI",
    "MVLAI",
    "MVPO",
    "MXOOA",
    "MYEO",
    "NACO",
    "NACOA",
    "NAEO",
    "NAGO",
    "NC6AU",
    "NC6OA",
    "NC6OB",
    "NCCO",
    "NESO",
    "NFLO",
    "NGHO",
    "NGLO",
    "NGSO",
    "NGSOA",
    "NHEO",
    "NHEOA",
    "NIOAM",
    "NISAF",
    "NISAO",
    "NMLAA",
    "NNGO",
    "NOROD",
    "NOUO",
    "NOVO",
    "NOVOA",
    "NOXO",
    "NOXOA",
    "NPHAI",
    "NPMO",
    "NRTAI",
    "NRTAK",
    "NRXO",
    "NRZO",
    "NRZOA",
    "NSBAI",
    "NSCOA",
    "NSLAO",
    "NSPAI",
    "NSTAK",
    "NSTAM",
    "NSTAO",
    "NSTOA",
    "NTIAI",
    "NTIOA",
    "NUZOA",
    "NVAAS",
    "NVGAU",
    "NVQO",
    "NVUAN",
    "NWFO",
    "NWMAH",
    "NWMAO",
    "NWMO",
    "NXMO",
    "NZSOB",
    "OAUAAA",
    "OB1O",
    "ODEO",
    "OECO",
    "OKJAI",
    "OKRO",
    "OM1O",
    "OPNOA",
    "OPTOA",
    "OPTOB",
    "ORDAK",
    "ORSAK",
    "ORXAS",
    "OSLAQ",
    "OSLO",
    "OSLOA",
    "OSLOB",
    "OSLOC",
    "OSPAU",
    "OSXAL",
    "OSXO",
    "OUMAI",
    "OUMAK",
    "OVNAJ",
    "OZZO",
    "PAAAI",
    "PAAO",
    "PABO",
    "PABOA",
    "PAIO",
    "PARO",
    "PAROA",
    "PBHAL",
    "PCEOC",
    "PCKAY",
    "PCLO",
    "PDIAK",
    "PDMAI",
    "PFEAO",
    "PFEO",
    "PFEOA",
    "PGDAT",
    "PGDO",
    "PGDOA",
    "PGOOB",
    "PGYO",
    "PGYOA",
    "PILAN",
    "PILO",
    "PIMO",
    "PKOAAB",
    "PKOAAC",
    "PKOAAK",
    "PKOAQ",
    "PKOO",
    "PL3O",
    "PL3OA",
    "PLCO",
    "PMCO",
    "PNCO",
    "PNNAI",
    "PNNAL",
    "PNNO",
    "PNTAG",
    "PNTO",
    "PNTOA",
    "PODO",
    "PODOA",
    "POSAAB",
    "PR1OA",
    "PR1OB",
    "PR2O",
    "PRMAY",
    "PRMOB",
    "PRRAD",
    "PRSOA",
    "PRWAK",
    "PRXAM",
    "PSAAU",
    "PSLAO",
    "PSLOD",
    "PTXOC",
    "PURO",
    "PV1OA",
    "PVLAK",
    "PVLO",
    "PXXO",
    "QBLAK",
    "QBLAM",
    "QEMAI",
    "QEMO",
    "QRSO",
    "QURAI",
    "RACAK",
    "RACAU",
    "RADO",
    "RADOA",
    "RAGO",
    "RAGOC",
    "RAGOD",
    "RB6O",
    "RC1O",
    "RCCO",
    "RCLAU",
    "RDMAAC",
    "RDNO",
    "RDNOA",
    "REEO",
    "REMAO",
    "REMO",
    "RFXAM",
    "RFXAS",
    "RGIOA",
    "RGIOB",
    "RGLO",
    "RGPAM",
    "RGXAI",
    "RHOO",
    "RHYAK",
    "RHYAL",
    "RHYO",
    "RLFO",
    "RLGO",
    "RLLAS",
    "RMLO",
    "RMLOB",
    "RMXO",
    "RMXOK",
    "RNEO",
    "RNTO",
    "RNTOB",
    "ROBAI",
    "ROLAK",
    "RPMO",
    "RR1O",
    "RR1OA",
    "RR1OB",
    "RR1OC",
    "RRSAK",
    "RSHO",
    "RTIO",
    "RWDAU",
    "RWDAY",
    "RWDO",
    "RXLAX",
    "SALAC",
    "SAUAS",
    "SBROB",
    "SCDAK",
    "SCNO",
    "SCTAT",
    "SCUAT",
    "SENAN",
    "SENO",
    "SGAO",
    "SGQO",
    "SHCAK",
    "SHPO",
    "SHXAU",
    "SI6O",
    "SI6OE",
    "SISO",
    "SITAQ",
    "SIUAM",
    "SKMO",
    "SKNAX",
    "SKNOC",
    "SKNOD",
    "SLAAI",
    "SLAAO",
    "SLSO",
    "SLZO",
    "SMAAI",
    "SMDAK",
    "SMGOA",
    "SMIAK",
    "SMIAU",
    "SMMO",
    "SMNAN",
    "SMNO",
    "SMNOA",
    "SMSO",
    "SMXO",
    "SP1AO",
    "SP3AR",
    "SPAAAC",
    "SPAAAF",
    "SPAAZ",
    "SPAO",
    "SPQAI",
    "SPQAK",
    "SPQAN",
    "SPQOB",
    "SPTO",
    "SPXO",
    "SPXOA",
    "SQXO",
    "SRNOD",
    "STAAK",
    "STAAM",
    "STKOA",
    "STXO",
    "SUHO",
    "SUHOA",
    "SUMO",
    "SURAI",
    "SVGAJ",
    "SVGO",
    "SVYO",
    "SVYOA",
    "SYAOC",
    "SYGO",
    "SYTAI",
    "T92O",
    "TARAX",
    "TASAI",
    "TASAM",
    "TASAO",
    "TASOE",
    "TATO",
    "TDXAI",
    "TEGO",
    "TEGOA",
    "TEMO",
    "TEMOA",
    "TESO",
    "TG1O",
    "TGNAU",
    "THROA",
    "THROC",
    "THROD",
    "TJNAI",
    "TKFAI",
    "TKLAW",
    "TKMO",
    "TLGAZ",
    "TM1O",
    "TMBAM",
    "TMGO",
    "TMGOB",
    "TMGOC",
    "TMGOD",
    "TMKO",
    "TMKOB",
    "TMKOC",
    "TMSO",
    "TMSOA",
    "TMXAS",
    "TMXAT",
    "TMXAU",
    "TMXAV",
    "TMXAW",
    "TMZAG",
    "TMZOB",
    "TNYAU",
    "TOEAA",
    "TOEO",
    "TONO",
    "TONOG",
    "TORAI",
    "TOUAD",
    "TRIOC",
    "TSIO",
    "TSLAJ",
    "TSLO",
    "TSLOA",
    "TSOO",
    "TSOOA",
    "TTIO",
    "TTMAV",
    "TTMAW",
    "TTMO",
    "TTTO",
    "TVNAX",
    "TVNO",
    "TVNOA",
    "UBIO",
    "UNIAQ",
    "UNTAQ",
    "UNTO",
    "UNTOA",
    "URMAQ",
    "UXCAK",
    "VARAW",
    "VENAQ",
    "VFXAT",
    "VKAAI",
    "VORAQ",
    "VR1O",
    "VRCOB",
    "VRLOF",
    "VRXAAA",
    "VRXAZ",
    "VRXOA",
    "VSRO",
    "VTIOA",
    "VTXO",
    "VTXOA",
    "VXRAO",
    "VXRAQ",
    "VXRAW",
    "W2VO",
    "WBEAI",
    "WBEAP",
    "WC1O",
    "WC1OA",
    "WCNAI",
    "WCNO",
    "WCNOE",
    "WFLO",
    "WFLOA",
    "WFLOB",
    "WGLAM",
    "WHKAK",
    "WHKO",
    "WINAV",
    "WMCOC",
    "WMLOB",
    "WMLOC",
    "WNRAR",
    "WNXAM",
    "WNXO",
    "WOAO",
    "WPGAQ",
    "WSRO",
    "WSROA",
    "WYXO",
    "X2MO",
    "XRGAU",
    "XTCO",
    "XTCOA",
    "YAROB",
    "YAROD",
    "YRLAI",
    "YRLAL",
    "YRLAS",
    "YRRAK",
    "ZEUAW",
    "ZEUO",
    "ZMLAE",
    "ZMMOD",
    "ZNOAR",
    "ZTAAZ"
];
